import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  AdvisoryBriefDocument,
  COMPETITOR_ANALYSIS_PREPARED_FIXTURE,
  DEVELOPMENT_FIRESTORE_COMPETITOR_SAMPLE,
} from '../../advisory/composites/ui';
import { AdvisoryCalloutState } from './components/AdvisoryCalloutState';

export interface AdvisoryDemoEnvironment {
  nodeEnv?: string;
  firebaseProjectId?: string;
}

const runtimeEnvironment = (): AdvisoryDemoEnvironment => ({
  nodeEnv: process.env.NODE_ENV,
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
});

export const isCompetitorAnalysisDemoEnabled = (environment: AdvisoryDemoEnvironment): boolean =>
  environment.nodeEnv === 'development' ||
  environment.nodeEnv === 'test' ||
  environment.firebaseProjectId === 'development-477809';

export function AdvisoryCompetitorAnalysisDemoPage({
  environment = runtimeEnvironment(),
}: {
  environment?: AdvisoryDemoEnvironment;
}) {
  const [searchParams] = useSearchParams();

  if (!isCompetitorAnalysisDemoEnabled(environment)) {
    return (
      <AdvisoryCalloutState
        tone="info"
        headingKey="advisory:callout.absent.heading"
        bodyKey="advisory:errors.notFound"
      />
    );
  }

  const sample = searchParams.get('sample');
  const model =
    sample === 'firestore-latest' || sample === 'firestore-right-to-win'
      ? DEVELOPMENT_FIRESTORE_COMPETITOR_SAMPLE
      : COMPETITOR_ANALYSIS_PREPARED_FIXTURE;

  return <AdvisoryBriefDocument model={model} />;
}

export default AdvisoryCompetitorAnalysisDemoPage;
